import { NAME_SPLIT_FIELD, NON_VISIBLE_FIELDS, PREFERED_COLUMN, PREFERED_COLUMN_ORDER } from './const';

/**
 * It takes an array of strings and returns a new array of strings with the strings in the original
 * array in the same order, but with the strings in the PREFERED_COLUMN array at the beginning of the
 * new array
 * @param {string[]} columnData - This is the array of columns that you want to sort.
 */
export const sortColumnOrder = (columnData: string[]) => {
    const newColumnOrder = PREFERED_COLUMN.filter((column) => columnData.includes(column));
    const splitColumnData = columnData.filter((column) => !PREFERED_COLUMN.includes(column));

    return [...newColumnOrder, ...splitColumnData];
};

export const filtreAndOrderColumns = (
    tableHeader: string[],
    preferedColumnOrder: string[] = PREFERED_COLUMN_ORDER,
    nonVisibleFields: string[] = NON_VISIBLE_FIELDS,
) => {
    const authorizedSort = [...preferedColumnOrder];
    let headerArray = tableHeader.filter((header) => !nonVisibleFields.includes(header));
    const indexNameSplit = authorizedSort.indexOf(NAME_SPLIT_FIELD);

    let customColumns: string[] = [];

    if (indexNameSplit !== -1) {
        customColumns = headerArray.filter((elem) => elem.match(/^name_split_[0-9]+$/));
        authorizedSort.splice(indexNameSplit, 1, ...customColumns);
    }

    const nameLangColumns = headerArray.filter((elem) => elem.includes('name_'));
    authorizedSort.splice(2, 0, ...nameLangColumns);

    headerArray = authorizedSort
        .filter((elem) => headerArray.includes(elem))
        .concat(headerArray.filter((elem) => !customColumns.includes(elem) && !authorizedSort.includes(elem)).sort());

    return headerArray;
};
